import { Box, Card } from "@mui/material";
import Bread from "../header/Bread";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ProgressCom from "../../components/ProgressCom";

function Detail(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);

  return (
    <Box sx={{ height: "92%" }}>
      <Bread breadChilds={props.breadChilds ? props.breadChilds : ""}></Bread>
      <Box sx={{ p: 2, pt: 0, height: "93%" }}>
        <Card
          sx={{
            height: "100%",
            overflowY: "auto",
            p: props.breadChilds.normargin ? 0 : 2,
            borderRadius: 3,
          }}
          raised
        >
          {props.children}
        </Card>
      </Box>
      {progress ? <ProgressCom /> : ""}
    </Box>
  );
}

export default Detail;
